import React from 'react';
import styled from 'styled-components';
// --------------------------------------------------------------------------------
import { config, Icons } from '../index';

export interface ActionIconProps {
  /* Icon  name */
  icon?: string;
  /* Icon stroke color */
  fill?: string;
  /* Icon hover fill */
  hoverFill?: string;
  /* Icon size */
  size?: number;
  /* Icon background color */
  backgroundColor?: string;
  /* Icon padding */
  padding?: string;
  /* Icon margin */
  margin?: string;
  /* Icon border */
  border?: string;
  /* Icon border radius */
  borderRadius?: string;
  /* Icon show state */
  display?: boolean;
  // --------------------------------------------------------------------------------
  /* Icon onClick handler */
  onClick?: () => void;
}

// --------------------------------------------------------------------------------
// 📌  Default style configuration for Accordion
// --------------------------------------------------------------------------------
const styleConfig = {
  backgroundColor: config.transparent,
  padding: config.spacingSmall,
  border: `1px solid ${config.muted}`,
  borderRadius: '50%',
};

const StyledWrapper = styled.div<ActionIconProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  cursor: pointer;
  transition: ${config.transitionShort};

  &:hover {
    opacity: ${(props) => (props.onClick ? 0.8 : 1)};
    background-color: ${(props) => props.hoverFill};
  }
`;

export const ActionIcon: React.FC<ActionIconProps> = ({
  icon = 'plus',
  backgroundColor = styleConfig.backgroundColor,
  padding = styleConfig.padding,
  margin,
  border = styleConfig.border,
  borderRadius = styleConfig.borderRadius,
  fill,
  hoverFill,
  display = true,
  size,
  // --------------------------------------------------------------------------------
  onClick,
  // additional props
  ...props
}) => {
  if (!display) return null; // 👉 if display is false, return null

  return (
    <StyledWrapper
      backgroundColor={backgroundColor}
      padding={padding}
      margin={margin}
      border={border}
      hoverFill={hoverFill}
      borderRadius={borderRadius}
      onClick={onClick}
      // any additional props that override the defaults
      {...props}
    >
      <Icons
        icon={icon}
        size={size}
        fill={fill}
        // hoverFill={hoverFill} // 👉 pass down the hover fill color
        onClick={() => {}}
      />
    </StyledWrapper>
  );
};
